import { DollarApollo } from "vue-apollo/types/vue-apollo";
import Mutation from "./mutation.gql";

export interface CreateGroupsWithAdminResult {
  groupName: string;
  adminName: string;
  email: string;
  allowRescue?: boolean;
  loginId: string;
  password: string;
}

export interface RawResult {
  createGroupsWithAdmin: CreateGroupsWithAdminResult[];
}

export interface InputError {
  row: number;
  name:
    | "グループ名"
    | "管理ユーザー名"
    | "メールアドレス"
    | "入居時リモート解施錠";
  message: string;
}

export interface Result {
  data?: CreateGroupsWithAdminResult[];
  errors?: InputError[];
}

export const createGroupsWithAdmin = async <V>(
  apollo: DollarApollo<V>,
  input: string
): Promise<Result> => {
  const result = await apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: { input },
    errorPolicy: "all"
  });
  await apollo.provider.defaultClient.cache.reset();

  const data = result.data ? result.data.createGroupsWithAdmin : undefined;
  const errors = result.errors
    ? ((result.errors[0]!.extensions!.exception!.errors ||
        []) as InputError[]).sort((a, b) => a.row - b.row)
    : undefined;

  return { data, errors };
};
